import { useEffect, useState } from "react";
import { getReviews } from "../api";
import { REVIEWS as MOCK, CONTACT, BRANCHES } from "../mock";

const FALLBACK = {
  source: "curated",
  rating: Number(CONTACT.rating),
  review_count: Number(CONTACT.reviews),
  maps_url: BRANCHES[1].mapsLink,
  reviews: MOCK.map((r) => ({
    author: r.author,
    initial: r.initial,
    rating: r.stars,
    relative_time: r.date,
    profile_photo: null,
    profile_url: null,
    text: r.text,
  })),
};

export const useReviews = () => {
  const [data, setData] = useState(FALLBACK);
  useEffect(() => {
    let alive = true;
    getReviews()
      .then((d) => {
        if (alive && d && Array.isArray(d.reviews) && d.reviews.length) setData(d);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  return data;
};
